import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import kt from "./filter.js";
import { isArray as p } from "../../util/code-utils.js";

var Bt = /*#__PURE__*/function () {
  function Bt(t) {
    _classCallCheck(this, Bt);

    this.filters = t;
  }

  _createClass(Bt, [{
    key: "Ql",
    value: function Ql(t) {
      var r = !0;

      for (var e = 0; e < this.filters.length; e++) {
        var o = this.filters[e];
        var s = !1;

        for (var _r = 0; _r < o.length; _r++) {
          if (o[_r].Ql(t)) {
            s = !0;
            break;
          }
        }

        if (!s) {
          r = !1;
          break;
        }
      }

      return r;
    }
  }, {
    key: "ss",
    value: function ss() {
      var t = [];

      for (var r = 0; r < this.filters.length; r++) {
        var e = this.filters[r],
            o = [];

        for (var _t = 0; _t < e.length; _t++) {
          o.push(e[_t].ss());
        }

        t.push(o);
      }

      return t;
    }
  }], [{
    key: "fromJson",
    value: function fromJson(t) {
      if (null == t || !p(t)) return null;
      var r = [];

      for (var e = 0; e < t.length; e++) {
        var o = [],
            s = t[e];

        for (var _t2 = 0; _t2 < s.length; _t2++) {
          o.push(kt.fromJson(s[_t2]));
        }

        r.push(o);
      }

      return new Bt(r);
    }
  }, {
    key: "yn",
    value: function yn(t) {
      var r = [];

      for (var e = 0; e < t.length; e++) {
        var o = [],
            s = t[e];

        for (var _t3 = 0; _t3 < s.length; _t3++) {
          o.push(kt.yn(s[_t3]));
        }

        r.push(o);
      }

      return new Bt(r);
    }
  }]);

  return Bt;
}();

export { Bt as default };